import { RoleCode } from '@ninety/platform/models/_shared/role-code';
import { BusinessOperatingSystem } from '@ninety/platform/models/company/business-operating-system.enum';

export enum NinetyPlatform {
  Web = 'web',
  Mobile = 'mobile',
}

/**
 * Global Context is a feature of Gainsight PX that allows for storing metadata for a
 * session that automatically gets added to events. This feature helps us with users
 * in multiple companies by storing their metadata at the session/event level, not
 * just on their PX user record, which is overwritten when they switch acccounts.
 *
 * Reference:
 * https://support.gainsight.com/PX/Engagements/01On-boarding/Use_Global_Context
 */
export interface IGainsightGlobalContext extends Record<string, string | boolean | number> {
  currentUserId: string;
  currentUserIsImplementer: boolean;
  currentUserRoleCode: RoleCode;
  currentUserRoleName: string;
  currentPersonId: string;
  currentUserCompany: string;
  currentUserCompanyBos: BusinessOperatingSystem;
  isLeadership: boolean;
  ninetyPlatform: NinetyPlatform;
}
